export default "__VITE_ASSET__Cm1r1g7G__"